import {ConfirmAsyncOpDialogBaseProps} from "../ConfirmAsyncOpDialog/ConfirmAsyncOpDialogBaseProps";
import {MC_Device} from "../../../iot/MC_Device";
import ConfirmAsyncOpDialog from "../ConfirmAsyncOpDialog/ConfirmAsyncOpDialog";
import {MC_Backend} from "../../../MC_Backend";
import {MC_Template_Role} from "../../../iot/MC_Parent_Template";

export interface RemoveChildDeviceFromRoleDialogProps extends ConfirmAsyncOpDialogBaseProps<any> {
    parent: MC_Device;
    role: MC_Template_Role | null;
    child: MC_Device | null;
}
function RemoveChildDeviceFromRoleDialog(props: RemoveChildDeviceFromRoleDialogProps) {
    const parent = props.parent;
    const role = props.role;
    const child = props.child;
    // No UI unless all required data is present
    if (role == null || child == null) {
        return null;
    }
    // Data
    const desc: string = "You're about to remove '" + child.name + "' from parent '" + parent.name + "'.";
    const successMsg: string = "Child '" + child.name + "' has been removed.";
    // Helper fn
    const performAction = () => {
        return MC_Backend.getInstance().updateChildDeviceRelation(
            child, parent,
            role.id, "remove"
        );
    };
    // UI
    return <ConfirmAsyncOpDialog<void>
        open={props.open}
        closeDialogFn={props.closeDialogFn}
        title={"Remove Child?"}
        desc={desc}
        confirmText={"Remove"}
        confirmTextRed={true}
        successMsg={successMsg}
        performAction={performAction}
        doneSuccessFn={props.doneSuccessFn}
        doneFailureFn={props.doneFailureFn}
    />;
}

export default RemoveChildDeviceFromRoleDialog;